export const API_KALORI = "https://tulufali.rotendaokab.go.id/api/";
//'http://localhost:4000/api/admin/';

export const API_TULUFALI = "https://sio-esa.rotendaokab.go.id/api/";
//'http://localhost:5000/api/admin/';
//'http://localhost:4000/api/admin/';
//https://aumafada.rotendaokab.go.id/api/
//https://manek.rotendaokab.go.id/api/
//"https://tulufali.rotendaokab.go.id/api/"

//'https://smartservice.rotendaokab.go.id/api/admin/';
//export const API_SMART = 'http://192.168.43.39:4000/api/';

export const GET_INDIVIDU_KECAMATAN = API_TULUFALI + "individu/kecamatan/";
export const GET_KELUARGA_KECAMATAN = API_TULUFALI + "keluarga/kecamatan/";

export const GET_BANTUAN_TAHUN = API_TULUFALI + "bantuantahun/ambil/tahun/";

export const GET_BANTUAN_JENIS = API_TULUFALI + "bantuan/ambil/jenis/";

export const POST_BANTUAN_JENIS = API_TULUFALI + "bantuan/simpan/jenis/";

export const POST_BANTUAN_TAHUN = API_TULUFALI + "bantuantahun/ambil";

export const DELETE_BANTUAN_TAHUN = API_TULUFALI + "bantuantahun/";

export const DELETE_BANTUAN_JENIS = API_TULUFALI + "bantuanjenis/";

export const GET_BANTUAN_TAHUN_AMBIL = API_TULUFALI + "bantuantahun/ambil/";

export const GET_BANTUAN_TAHUN_KATEGORI =
  API_TULUFALI + "databantuan/kategori/";

export const GET_BANTUAN = API_TULUFALI + "databantuan/";
export const DELETE_BANTUAN = API_TULUFALI + "databantuan/";

export const DATA_BANTUAN_API = API_TULUFALI + "databantuan/";

export const GET_INDIVIDU_DESIL_DESA = API_TULUFALI + "individu/perdesil/desa";
export const GET_DTSEN_DESIL_DESA = API_TULUFALI + "dtsen/perdesil/desa";
export const GET_REKAP_DTSEN_DESA = API_TULUFALI + "rekap-dtsen/desa";
export const GET_REKAP_DTSEN_KECAMATAN = API_TULUFALI + "rekap-dtsen/kecamatan";
export const GET_DTSEN_DESIL_DESA_DETAIL =
  API_TULUFALI + "dtsen/perdesil/desa/detail";
export const GET_INDIVIDU_DESIL_KECAMATAN =
  API_TULUFALI + "individu/perdesil/kecamatan";
export const GET_DTSEN_DESIL_KECAMATAN =
  API_TULUFALI + "dtsen/perdesil/kecamatan";
export const GET_DTSEN_DESIL_KECAMATAN_DETAIL =
  API_TULUFALI + "dtsen/perdesil/kecamatan/detail";
export const GET_DTSEN_CARI_INDIVIDU = API_TULUFALI + "dtsen/cari-individu";

export const BANTUAN_TAHUN_API = API_TULUFALI + "bantuantahun/";

export const BANTUAN_JENIS_API = API_TULUFALI + "bantuanjenis/";

export const BANTUAN_API = API_TULUFALI + "bantuan/";

export const BANTUAN_DINAS_API = API_TULUFALI + "bantuan/dinas/";

export const CARI_DATA_MISKIN_LIKE = API_TULUFALI + "datamiskin/cari/like";
export const CARI_DTSEN_LIKE = API_TULUFALI + "dtsen/cari/like";

export const CARI_DATA_MISKIN_LIKE_DTKS =
  API_TULUFALI + "datamiskin/cari/like/dtks";

export const CARI_NIK_DTKS = API_TULUFALI + "dtks/";

export const CARI_NIK_DUKCAPIL = API_TULUFALI + "dukcapil/";

export const GET_KECAMATAN = API_TULUFALI + "kecamatan";
export const GET_DESA = API_TULUFALI + "desa";
export const PROGRESS_BANTUAN_API = API_TULUFALI + "progresbantuan/";

export const HISTORI_BANTUAN_API = API_TULUFALI + "historibantuan/";
export const PROGRESS_DINAS_API = API_TULUFALI + "progresdinas/";

export const AKUMULASI_BANTUAN_TAHUN = API_TULUFALI + "ambil/akumulasibantuan/";
export const AKUMULASI_BANTUAN_NOKK = API_TULUFALI + "ambil/akumulasibantuannokk";

export const VALIDASI_BANTUAN = API_TULUFALI + "validasibantuan/";
export const VALIDASI_HISTORI = API_TULUFALI + "validasihistori/";
export const PIRAMIDA_PENDUDUK = API_TULUFALI + "piramidapenduduk/";
export const PEKERJAAN_PENDUDUK = API_TULUFALI + "pekerjaanpendudukmiskin/";

export const PENDIDIKAN_KECAMATAN = API_TULUFALI + "pendidikankecamatan/";
export const DESIL_KESEJAHTERAAN_KECAMATAN =
  API_TULUFALI + "desilkesejahteraankecamatan/";
export const PADAN_DUKCAPIL = API_TULUFALI + "padandukcapil/";

export const VALIDASI_INPUT_BANTUAN = API_TULUFALI + "validasi/inputbantuan/";

export const VALIDASI_INPUT_JENIS_BANTUAN =
  API_TULUFALI + "validasi/inputjenisbantuan/";

export const LIMA_TAHUN_TERAKHIR = API_TULUFALI + "bantuan/limatahunterakhir";
export const BANTUAN_KARTU_LIMATAHUN = API_TULUFALI + "bantuan/kartu-limatahun";
export const BANTUAN_TOTAL_PER_TAHUN = API_TULUFALI + "bantuan/total-per-tahun";
export const AKUMULASI_DESIL_LIMATAHUN =
  API_TULUFALI + "bantuan/akumulasi-desil/limatahun";
export const ADMIN_LOGIN = API_TULUFALI + "admin/login";
export const ADMIN_TOKEN = API_TULUFALI + "admin/token";
export const ADMIN_CHECK_STATUS = API_TULUFALI + "admin/check-status";
export const ADMIN_AUDIT_LOGS_ME = API_TULUFALI + "admin/audit-logs/me";
export const ADMIN_AUDIT_LOGS = API_TULUFALI + "admin/audit-logs";

export const DESA_BANTUAN_TAHUN = API_TULUFALI + "bantuan/desa/";
export const KECAMATAN_BANTUAN_TAHUN = API_TULUFALI + "bantuan/kecamatan/";
export const BANTUAN_LIST_TAHUN = API_TULUFALI + "bantuan/list/";
/** GET …/bantuan/riwayat-program-limatahun/:hinggaTahun?bantuan= — 5 tahun ke belakang dari tahun acuan */
export const BANTUAN_RIWAYAT_PROGRAM_LIMA_TAHUN =
  API_TULUFALI + "bantuan/riwayat-program-limatahun/";

export const UPDATE_SK = API_TULUFALI + "bantuantahun/updateSK/";
export const UPDATE_KUNCI = API_TULUFALI + "bantuantahun/updateKunci/";

export const LIST_ADMIN_TF = API_TULUFALI + "tulufali/admin/";

export const LOGOUT_ADMIN_TF = API_TULUFALI + "admin/";

export const VALIDASI_DIFABEL = API_TULUFALI + "difabelkel/";

export const GET_UKURAN = API_TULUFALI + "ukuran";
export const GET_ASUPAN = API_TULUFALI + "asupan";
export const POST_ASUPAN = API_TULUFALI + "asupan/input";
export const GET_USER = API_TULUFALI + "user";
export const POST_USER = API_TULUFALI + "user/input";

export const POST_MAKAN = API_KALORI + "makan/input";
export const DELETE_MAKAN = API_KALORI + "makan/";
export const GET_MAKAN = API_KALORI + "makan/ambil";

export const GET_KONSUMSI_KALORI = API_KALORI + "makan/konsumsi";
export const GET_KEBUTUHAN_KALORI = API_KALORI + "kebutuhankalori";
export const GET_KONSUMSI_KALORI_KATEGORI =
  API_KALORI + "makan/konsumsi/kategori";
export const GET_KONSUMSI_KALORI_HARI = API_KALORI + "konsumsi/kalori/hari";

export const DINAS_PERANGKAT_DAERAH = API_TULUFALI + "dinas/perangkat-daerah";
export const BELANJA_MAMIN_PD_TAHUN = API_TULUFALI + "belanja-mamin-pd/tahun/";
export const BELANJA_MAMIN_PD = API_TULUFALI + "belanja-mamin-pd";
export const BELANJA_MAMIN_PD_REKAP = API_TULUFALI + "belanja-mamin-pd/rekap";
export const BELANJA_MAMIN_PD_UPLOAD = API_TULUFALI + "belanja-mamin-pd/upload-bulk";
export const BELANJA_MAMIN_PD_CHECK =
  API_TULUFALI + "belanja-mamin-pd/check-existing";

export const DINAS_BY_NAMA = API_TULUFALI + "dinas/by-nama";
export const DTSEN_BY_NIK = API_TULUFALI + "dtsen/nik/";
export const LAPORAN_BELANJA_MAMIN = API_TULUFALI + "laporan-belanja-mamin";
export const LAPORAN_BELANJA_MAMIN_REKAP =
  API_TULUFALI + "laporan-belanja-mamin/rekap-bulanan";
export const MAKAN_MINUM_DASHBOARD = API_TULUFALI + "makan-minum/dashboard";

export const API_TIMEOUT = 120000;

/** Teks sumber untuk judul/ekspor halaman desil (per desa & per kecamatan) */
export const DESIL_REKAP_DATA_SOURCE = 'DTSEN - Kemensos - April 2026';
